import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { FaTruckArrowRight } from "react-icons/fa6";
import { FaFileInvoiceDollar } from "react-icons/fa";
import { PiUsersFill } from "react-icons/pi";
import { BiCurrentLocation } from "react-icons/bi";
import { IoChatboxEllipsesOutline } from "react-icons/io5";
import { RiAdminFill } from "react-icons/ri";
import {
  MdDashboard,
  MdOutlineFactCheck,
  MdNotifications,
  MdOutlineHistory,
  MdSummarize,
} from "react-icons/md";
import { AiOutlineLogout } from "react-icons/ai";
import { NavLink, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { logoutUserSuccess } from "../../store/actions";
import "../../styles/sidebar.css";

const NAV_ITEMS = [
  { to: "/dashboard/allocation-control", label: "Allocation Control", description: "Order flow, failures and retries", icon: MdOutlineFactCheck },
  {
    to: "/dashboard/tours",
    label: "Tours",
    description: "Bookings, trips and tours",
    icon: FaTruckArrowRight,
  },
  {
    to: "/dashboard/accounts",
    label: "Accounts",
    description: "People, fleet and companies",
    icon: PiUsersFill,
  },
  {
    to: "/dashboard/liveLocation",
    label: "Live locations",
    description: "Track active drivers",
    icon: BiCurrentLocation,
  },
  {
    to: "/dashboard/sessionInfo",
    label: "Session info",
    description: "Driver session records",
    icon: IoChatboxEllipsesOutline,
  },
  {
    to: "/dashboard/summary",
    label: "Summary",
    description: "Daily and transaction views",
    icon: MdSummarize,
  },
  {
    to: "/dashboard/admin",
    label: "Admin",
    description: "Operational configuration",
    icon: RiAdminFill,
  },
  {
    to: "/dashboard/history",
    label: "Driver history",
    description: "History, maps and analysis",
    icon: MdOutlineHistory,
  },
  {
    to: "/dashboard/invoice",
    label: "Invoices",
    description: "Bookings and generated bills",
    icon: FaFileInvoiceDollar,
  },
  {
    to: "/dashboard/charts",
    label: "Dashboard",
    description: "Performance analytics",
    icon: MdDashboard,
  },
  {
    to: "/dashboard/notification",
    label: "Notifications",
    description: "Operational alerts",
    icon: MdNotifications,
  },
];

const SidebarContent = ({ logoutUserSuccess, onNavigate }) => {
  const navigate = useNavigate();
  const managerMobile = localStorage.getItem("managerMobile") || "Manager account";

  useEffect(() => {
    const storedLoginState = localStorage.getItem("isLoggedIn");
    const isLoggedIn = storedLoginState ? JSON.parse(storedLoginState) : false;

    if (isLoggedIn !== true) {
      navigate("/");
    }
  });

  const logoutCall = () => {
    sessionStorage.removeItem("managerDashboardToken");
    logoutUserSuccess();
    localStorage.setItem("isLoggedIn", JSON.stringify(false));
    onNavigate();
    navigate("/");
  };

  return (
    <nav className="sidebar-navigation" aria-label="Main navigation">
      <p className="sidebar-navigation__label">Workspace</p>

      <ul className="sidebar-navigation__list">
        {NAV_ITEMS.map(({ to, label, description, icon: Icon }) => (
          <li key={to}>
            <NavLink
              to={to}
              onClick={onNavigate}
              className={({ isActive }) =>
                `sidebar-navigation__link ${isActive ? "is-active" : ""}`
              }
            >
              <span className="sidebar-navigation__icon">
                <Icon aria-hidden="true" />
              </span>
              <span className="sidebar-navigation__copy">
                <strong>{label}</strong>
                <small>{description}</small>
              </span>
              <span className="sidebar-navigation__arrow" aria-hidden="true">›</span>
            </NavLink>
          </li>
        ))}
      </ul>

      <div className="sidebar-account">
        <div className="sidebar-account__identity">
          <span className="sidebar-account__avatar">GM</span>
          <span>
            <small>Signed in as</small>
            <strong>{managerMobile}</strong>
          </span>
        </div>
        <button type="button" className="sidebar-account__logout" onClick={logoutCall}>
          <AiOutlineLogout aria-hidden="true" />
          Logout
        </button>
      </div>
    </nav>
  );
};

SidebarContent.propTypes = {
  logoutUserSuccess: PropTypes.func.isRequired,
  onNavigate: PropTypes.func,
};

SidebarContent.defaultProps = {
  onNavigate: () => {},
};

export default connect(null, {
  logoutUserSuccess,
})(SidebarContent);


// import PropTypes from "prop-types"
// import React, { useEffect, useRef, useState } from "react";
// // Import React Icons .......
// import {FaTruckArrowRight} from "react-icons/fa6";
// import {PiUsersFill} from "react-icons/pi"
// import{BiCurrentLocation} from "react-icons/bi";
// import {IoChatboxEllipsesOutline} from "react-icons/io5";
// import {RiAdminFill} from "react-icons/ri";
// import {GrHistory} from  "react-icons/gr";
// import {MdOutlineHistory,MdDashboard,MdSummarize} from "react-icons/md"
// import {MdNotifications} from "react-icons/md";
// import { FaPowerOff } from "react-icons/fa";
// import { FaFileInvoiceDollar } from "react-icons/fa";

// import { NavLink,useNavigate,Redirect } from "react-router-dom";
// import { connect } from "react-redux";
// import "../../styles/sidebar.css";

// // //Import Scrollbar
// import SimpleBar from "simplebar-react"


// // MetisMenu
// import MetisMenu from "metismenujs"
// import { BrowserRouter } from "react-router-dom"
// import { Link } from "react-router-dom"

// //i18n
// import { withTranslation } from "react-i18next"
// import { AiOutlineLogout } from "react-icons/ai";

// import {logoutUserSuccess} from "../../store/actions"


// const SidebarContent = props => {
//   const[isActive,setIsActive]=useState(false);
//   const navRef=useRef();
//   const navRef1=useRef();
//   const checking=(e)=>{
//     if(e.target.baseURI == "http://localhost:3000/dashboard/admin/addAddress"){
//       navRef.current.classList.add("bactive");
//       console.log(e);
//     }
//   }
//   const checking1=(e)=>{
//     if(e.target.baseURI == "http://localhost:3000/dashboard/history/historyTable"){
//       navRef.current.classList.remove("bactive");
//       navRef1.current.classList.add("cactive");
//       console.log(e);
//     }
//   }
  
//   const ref=useRef();
//   // Use ComponentDidMount and ComponentDidUpdate method symultaniously
//   useEffect(() => {
//     const pathName = props.location

//     const initMenu = () => {
//       new MetisMenu("#side-menu")
//       let matchingMenuItem = null
//       const ul = document.getElementById("side-menu")
//       const items = ul.getElementsByTagName("a")
//       for (let i = 0; i < items.length; ++i) {
//         if (pathName === items[i].pathname) {
//           matchingMenuItem = items[i]
//           break
//         }
//       }
//       if (matchingMenuItem) {
//         activateParentDropdown(matchingMenuItem)
//       }
//     }
//     initMenu()
//   }, [props.location])

//   useEffect(() => {
//     ref.current.recalculate()
//   })

//   function scrollElement(item) {
//     if (item) {
//       const currentPosition = item.offsetTop
//       if (currentPosition > window.innerHeight) {
//         ref.current.getScrollElement().scrollTop = currentPosition - 300
//       }
//     }
//   }

//   function activateParentDropdown(item) {
//     item.classList.add("active")
//     const parent = item.parentElement
//     const parent2El = parent.childNodes[1]
//     if (parent2El && parent2El.id !== "side-menu") {
//       parent2El.classList.add("mm-show")
//     }

//     if (parent) {
//       parent.classList.add("mm-active")
//       const parent2 = parent.parentElement

//       if (parent2) {
//         parent2.classList.add("mm-show") // ul tag

//         const parent3 = parent2.parentElement // li tag

//         if (parent3) {
//           parent3.classList.add("mm-active") // li
//           parent3.childNodes[0].classList.add("mm-active") //a
//           const parent4 = parent3.parentElement // ul
//           if (parent4) {
//             parent4.classList.add("mm-show") // ul
//             const parent5 = parent4.parentElement
//             if (parent5) {
//               parent5.classList.add("mm-show") // li
//               parent5.childNodes[0].classList.add("mm-active") // a tag
//             }
//           }
//         }
//       }
//       scrollElement(item);
//       return false
//     }
//     scrollElement(item);
//     return false
//   }
//   const navigate=useNavigate()

  
    
//     const getActivation=()=>{
//       const isLogged = localStorage.getItem("isLoggedIn");
//       const isLoggedIn = JSON.parse(isLogged);
//       console.log(isLoggedIn,"lokk");
//       if(isLoggedIn !== true){
//         navigate("/")

//       }

//     }

//    useEffect(()=>{
//     getActivation()
//    })

//    const logoutCall=()=>{
//       props.logoutUserSuccess()
//       localStorage.setItem("isLoggedIn", JSON.stringify(false));
//       navigate("/");
//    }
    

  

  

//   return (
//     <React.Fragment>
//       <SimpleBar style={{ maxHeight: "100%"}} ref={ref}>
//         <div id="sidebar-menu" >
//           <ul className="metismenu list-unstyled" id="side-menu" >
//             {/* <li className="menu-title">{props.t("Dashboard")} </li> */}
//             {/* Tours link */}
//             <li style={{display:"flex",flexDirection:"column",marginBottom:"10px"}}> 
//               <NavLink to="/dashboard/tours" activeClassName="sideBar-testing"  style={{display:"flex",gap:"8px",fontSize:"20px"}}>
//                   <div>
//                   <span> <FaTruckArrowRight size={18} color={"black"}/></span> 
//                   {/* className="menu-options" */}
//                   </div>               
//                   <div>
//                   <span  style={{fontSize:"14px",color:"black"}} >{("TOURS")}</span> <br />
//                   <span className="subtitle" style={{color:"grey",position:"relative",left:"-20px",fontSize:"12px"}}>Manage trips and tours.</span>
//                   </div>
//               </NavLink>
//             </li>
            

//             <li> 
//               <NavLink to="/dashboard/accounts" className="" style={{display:"flex",gap:"8px",fontSize:"20px",marginBottom:"10px"}}>
//                   <div>
//                     <span><PiUsersFill size={18} color={"black"}/></span>
//                     {/* className="menu-options" */}
//                   </div>
//                   <div>
//                     <span  style={{fontSize:"14px",color:"black"}}>{("ACCOUNTS")}</span> <br />
//                     <span className="subtitle" style={{color:"grey",position:"relative",left:"-20px",fontSize:"12px"}}>Manage owners,drivers & vehicles</span>
//                   </div>
//               </NavLink>
              
//             </li>

//             <li>
//               <NavLink to="/dashboard/liveLocation" className="" style={{display:"flex",gap:"8px",fontSize:"20px",marginBottom:"10px"}}>
//                   <div>
//                   <span> <BiCurrentLocation size={18} color={"black"}/></span>
//                   </div>
//                   <div>
//                   <span style={{fontSize:"14px",color:"black"}}>{("LIVE LOCATIONS")}</span> <br/>
//                   <span className="subtitle" style={{color:"grey",position:"relative",left:"-20px",fontSize:"12px"}}>View live driver locations.</span>
//                   </div>
//               </NavLink>
              
//             </li>
//             <li>
//               <NavLink to="/dashboard/sessionInfo" ref={navRef} onClick={(e)=>checking(e)} 
//               style={{display:"flex",gap:"8px",fontSize:"20px",marginBottom:"10px"}} >
//                   <div >
//                   <span> <IoChatboxEllipsesOutline size={18} color={"black"}/></span>
//                   </div>
//                   <div>
//                   <span className="menu-options"  style={{fontSize:"14px",color:"black"}}>{"SESSION INFO"}</span> <br/>
//                   <span className="subtitle" style={{color:"grey",position:"relative",left:"-20px",fontSize:"12px"}}>View  session  info</span>
//                   </div>
//               </NavLink>
//             </li>
            
//             <li>
//               <NavLink to="/dashboard/summary" 
//               style={{display:"flex",gap:"8px",fontSize:"20px",marginBottom:"10px"}} >
//                   <div >
//                   <span> <MdSummarize size={18} color={"black"}/></span>
//                   </div>
//                   <div>
//                   <span className="menu-options"  style={{fontSize:"14px",color:"black"}}>{"SUMMARY"}</span> <br/>
//                   <span className="subtitle" style={{color:"grey",position:"relative",left:"-20px",fontSize:"12px"}}>Summary Details</span>
//                   </div>
//               </NavLink>
//             </li>

//             <li>
//               <NavLink to="/dashboard/admin" className="" ref={navRef1} onClick={(e)=>checking1(e)} 
//               style={{display:"flex",gap:'8px',fontSize:"20px",marginBottom:"10px"}}>
//                 <div>
//                   <span> <RiAdminFill size={18} color={"black"}/></span>
//                 </div>
//                 <div>
//                     <span className="menu-options" style={{fontSize:"14px",color:"black"}}>{"ADMIN"}</span> <br/>
//                     <span className="subtitle" style={{color:"grey",fontSize:"12px",position:"relative",left:"-20px"}}>Admin workspace</span>
//                 </div>

//               </NavLink>
//             </li>
//             <li>
//               <NavLink to="/dashboard/history" className=""  style={{display:"flex",gap:'8px',fontSize:"20px",marginBottom:"10px"}}>
//                 <div><span>< MdOutlineHistory size={18} color={"black"} /></span></div>
//                 <div style={{}}>
//                   <span className="menu-options" style={{fontSize:"14px",color:"black"}}>{"DRIVER HISTORY"}</span> <br/>
//                   <span className="subtitle" style={{color:"grey",position:"relative",left:"-20px",fontSize:"12px"}}>Driver location history</span>
//                 </div>
//               </NavLink>
              
//             </li>
//             <li>
//               <NavLink to="/dashboard/invoice" className=""  style={{display:"flex",gap:'6px',fontSize:"20px",marginBottom:"10px"}}>
//                 <div><span>< FaFileInvoiceDollar size={18} color={"black"} /></span></div>
//                 <div style={{}}>
//                   <span className="menu-options" style={{fontSize:"14px",color:"black"}}>{"INVOICE"}</span> <br/>
//                   <span className="subtitle" style={{color:"grey",position:"relative",left:"-20px",fontSize:"12px"}}>Customer Invoices</span>
//                 </div>
//               </NavLink>
//             </li>
//             <li>
//               <NavLink to="/dashboard/charts" className=""  style={{display:"flex",gap:'6px',fontSize:"20px",marginBottom:"10px"}}>
//                 <div><span>< MdDashboard size={18} color={"black"} /></span></div>
//                 <div style={{}}>
//                   <span className="menu-options" style={{fontSize:"14px",color:"black"}}>{"DASHBOARD"}</span> <br/>
//                   <span className="subtitle" style={{color:"grey",position:"relative",left:"-20px",fontSize:"12px"}}>Dashboard Layout</span>
//                 </div>
//               </NavLink>
//             </li>

//             <li>

//             <NavLink to="/dashboard/notification" className=""  style={{display:"flex",gap:'6px',fontSize:"20px",marginBottom:"10px"}}>
//                 <div><span>< MdNotifications size={18} color={"black"} /></span></div>
//                 <div style={{}}>
//                   <span className="menu-options" style={{fontSize:"14px",color:"black"}}>{"NOTIFICATIONS"}</span> <br/>
//                   <span className="subtitle" style={{color:"grey",position:"relative",left:"-20px",fontSize:"12px"}}>View Notifications</span>
//                 </div>
//               </NavLink>
            
// {/* 
//               <NavLink to="/dashboard/notification"   
//               style={{display:"flex",gap:'8px',fontSize:"18px",marginBottom:"10px"}}>
//                   <div>
//                   <span> <MdNotifications size={18} color={"black"}/></span>
//                   </div>
//                     <div style={{display:"flex",flexDirection:"column"}}>
//                       <span className="menu-options" style={{fontSize:"14px",color:"black"}}>{("NOTIFICATIONS")}</span>
//                       <span className="subtitle" style={{color:"grey",fontSize:"12px"}}>View Notifications</span>
//                     </div>

//               </NavLink>  */}
//                     {/* <div style={{backgroundColor:"red",color:"white",position:"absolute",left:"20px",top:"6px",
//                     height:"17px",textAlign:"center",width:"17px",fontSize:"10px",borderRadius:"50%"}}>09</div> */}

              
//             </li>
//             {/* /INvoicesss... */}
//             <li className="lastChild" style={{position:""}}>
//                 {/* <Link to="/"  > */}
//                   <div style={{display:"flex",flexDirection:"column",left:"40px",color:"grey",position:"relative"}}>
//                       <span>Logged in as </span>
//                       <span >XXXXXX</span>
//                   </div>
//                   <div style={{marginTop:"10px"}}
//                   onClick={logoutCall}
//                   >
//                   <span  style={{border:"1px solid black",padding:"4px",left:"40px",
//                   color:"black",position:"relative",borderRadius:"3px",cursor:"pointer"}}>
//                     <AiOutlineLogout size={16}/> Logout</span>
//                   </div>
                  
//                 {/* </Link> */}
//             </li>
//             {/* <li>
//               <Link to="/reports" className="">
//                 <i className="bx bx-home-circle"></i>
//                 <span>{props.t("Templates")}</span>
//               </Link>
//               <ul className="sub-menu" aria-expanded="false">
//                 <li>
//                   <Link to="/pdf-template/add">{props.t("Add")}</Link>
//                 </li>
//                 <li>
//                   <Link to="/template">{props.t("List")}</Link>
//                 </li>
//               </ul>
//             </li> */}
//           </ul>
//         </div>
//       </SimpleBar>
//     </React.Fragment>
//   )
// }


// const mapStateToProps = (state) => {
//   console.log(state,"from sidefor");
//   const { error, isUserFound,message } = state.Login
//   console.log(error, isUserFound,message);
//   return { error, isUserFound,message };
// };
// // export default connect(mapStateToProps, {
// //   // userCheck,
// //   // apiError,
// //   // socialLogin,
// //   // checkUserMobile
// //   // checkUserSuccess,
// //   logoutUserSuccess
  
// // })(SidebarContent);


// SidebarContent.propTypes = {
//   location: PropTypes.object,
//   t: PropTypes.any,
// }

// // export default withTranslation()(SidebarContent)
// export default connect(mapStateToProps, {
//   logoutUserSuccess
// })(SidebarContent);